import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface SurveyViewNameDTO {
  name: string;
}

export class SurveyViewName {
  readonly isSurveyViewNameSurveyViewName: boolean = true;

  readonly name: string;

  static readonly constraints = {
    "name": {
      "minSize": 4,
      "maxSize": 128,
      
      
      
      
    }
  }

  constructor(
  name: string
  ) {
    SurveyViewName.validateName(name);
    this.name = name;
  }

  static fromDTO(dto: SurveyViewNameDTO): SurveyViewName {
    const name = getString(dto, "name", InvalidSurveyViewNameNameError);
    return new SurveyViewName(
      name
    );
  }

  toDTO(): SurveyViewNameDTO {
    const dto: SurveyViewNameDTO = {
        name: this.name
    };
    return dto;
  }
  private static validateName = (name: string): void => {
    if(name.length < 4) {
      throw new InvalidSurveyViewNameNameMinSizeError(
        4,
        `Attribute name is too short. Size is ${name.length}. Min size is 4.`
      );
    }
    if(name.length > 128) {
      throw new InvalidSurveyViewNameNameMaxSizeError(
        128,
        `Attribute name is too long. Size is ${name.length}. Max size is 128.`
      );
    }
      if(name.trim().length === 0) {
        throw new InvalidSurveyViewNameNameNonEmptyError(
          `Attribute name cannot be an empty string.`
        );
      }
  }
  
}

SurveyViewName.prototype.toString = function toString(): string {
  return `SurveyViewName(name='${this.name}')`;
};

export class InvalidSurveyViewNameError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewNameError";
  }
}
export class InvalidSurveyViewNameNameError extends InvalidSurveyViewNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewNameNameError";
  }
}

export class InvalidSurveyViewNameNameMaxSizeError extends InvalidSurveyViewNameNameError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewNameNameMaxSizeError";
  }
}

export class InvalidSurveyViewNameNameMinSizeError extends InvalidSurveyViewNameNameError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewNameNameMinSizeError";
  }
}

export class InvalidSurveyViewNameNameNonEmptyError extends InvalidSurveyViewNameNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewNameNameNonEmptyError";
  }
}
